<template>
  <span
    :class="{
      [color]: true,
      pill: isPill,
      'tag--wide': isWide,
      'tag--fill': fill
    }"
    class="tag"
  >
    <slot />
    <span
      v-if="withCloseButton"
      class="tag_close"
      aria-label="Close"
      @click="removeTag"
    >
      <span aria-hidden="true">&times;</span>
    </span>
  </span>
</template>
<script>
import '~style/components/tag.scss'
import '~style/components/pill.scss'
export default {
  name: 'Tag',
  props: {
    index: {
      type: [String, Number],
      default: ''
    },
    color: {
      type: String,
      default: 'blue'
    },
    isPill: {
      type: Boolean,
      default: true
    },
    isWide: {
      type: Boolean,
      default: false
    },
    fill: {
      type: Boolean,
      default: false
    },
    withCloseButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    removeTag () {
      this.$emit('remove:tag', this.index)
    }
  }
}
</script>
